import { render } from "./dutyStaticsListTiny.vue?vue&type=template&id=69283586&scoped=true"
import script from "./dutyStaticsListTiny.vue?vue&type=script&lang=js"
export * from "./dutyStaticsListTiny.vue?vue&type=script&lang=js"

import "./dutyStaticsListTiny.vue?vue&type=style&index=0&id=69283586&lang=scss"
import "./dutyStaticsListTiny.vue?vue&type=style&index=1&id=69283586&lang=scss&scoped=true"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69283586"]])

export default __exports__